import React from "react";

const Layout = ({ children }) => {
  return <div className="flex-row w-100">{children}</div>;
};

export default Layout;
